import { render, staticRenderFns } from "./SalesReportPage.vue?vue&type=template&id=704f6a25&"
import script from "./SalesReportPage.vue?vue&type=script&lang=ts&"
export * from "./SalesReportPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports